import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import React, { Component } from "react";
import { ConfigProvider, Form, Modal } from "antd";
import Button from '../../composite/button/Button';
import IconButton from '../../composite/iconButton/IconButton';
import Input from '../../primitive/input/Input';
import TextArea from '../../primitive/textarea/TextArea';
import Select from '../../composite/select/Select';
import Typography from "../../primitive/Typography/Typography";
import Map from '../map/Map';
import mapTarget from "../../../assets/MapTarget.svg";
import './Form.scss';
class FormComponent extends Component {
    constructor() {
        super(...arguments);
        this.formRef = React.createRef();
        this.state = {
            myForm: {},
            errorFieldKeys: [],
            errorFields: [],
            mapModal: false,
            currentAdressItemName: "",
            currentFieldName: '',
            mapCol: {},
            id,
            idFormText,
            idInputText,
            idFormNumber,
            idInputNumber,
            idFormTextarea,
            idTextArea,
            idFormDropDown,
            idSelectDropDown,
            idFormButton,
            idButton,
            idFormIconButton,
            idIconButton,
            idForm
        };
        this.toggleMapModalBox = (fieldName) => {
            fieldName ? this.setState({
                mapModal: !this.state.mapModal,
                currentFieldName: fieldName
            }) : this.setState({
                mapModal: !this.state.mapModal,
            });
        };
        this.handleAddressChange = (newAddress) => {
            const { currentFieldName } = this.state;
            if (!!newAddress) {
                this.formRef.current.setFieldsValue({
                    [currentFieldName]: newAddress,
                });
            }
            this.toggleMapModalBox(currentFieldName);
        };
        this.onFinish = (values) => {
            this.props.onFinish(values);
        };
    }
    componentDidMount() {
        this.setState({
            myForm: this.formRef.current,
        });
        if (this.props.formRef) {
            this.props.formRef.current = this.formRef;
        }
    }
    inputFocus(name) {
        console.log(name, this.formRef);
    }
    renderFieldType(col) {
        var _a, _b, _c;
        const { fieldtype } = col;
        switch (fieldtype) {
            case "text":
                return (_jsx(Form.Item, Object.assign({ id: idFormText, name: col.itemname, hasFeedback: true, className: `storybook__fieldItems ${col.className}`, rules: col.colRules }, { children: _jsx(Input, Object.assign({ id: idInputText }, col, { rtl: col.rtl, maxLength: col.maxLength, value: col.value, name: col.name, onChange: col.onChange, placeholder: `${col.placeholder}`, width: col.width, headingleft: col.headingleft, headingright: col.headingright, labelleft: col.labelleft, className: col.childclassname }), void 0) }), void 0));
            case "number":
                return (_jsx(Form.Item, Object.assign({ id: idFormNumber, name: col.itemname, hasFeedback: true, className: `storybook__fieldItems ${col.className}`, rules: col.colRules }, { children: _jsx(Input, Object.assign({ id: idInputNumber }, col, { rtl: col.rtl, maxLength: col.maxLength, value: col.value, name: col.name, onChange: col.onChange, placeholder: `${col.placeholder}`, width: col.width, headingleft: col.headingleft, headingright: col.headingright, labelleft: col.labelleft, className: col.childclassname }), void 0) }), void 0));
            case "textarea":
                return (_jsx(Form.Item, Object.assign({ id: idFormTextarea, name: col.itemname, hasFeedback: true, className: `storybook__fieldItems ${col.className}`, rules: col.colRules }, { children: _jsx(TextArea, { id: idTextArea, rows: col.rows, rtl: col.rtl, showCount: col.showCount, placeholder: `${col.placeholder}`, value: col.value, name: col.name, onChange: col.onChange, width: col.width, headingleft: col.headingleft, headingright: col.headingright, labelleft: col.labelleft, className: col.childclassname, maxLength: col.maxLength }, void 0) }), void 0));
            case "dropdown":
                return (_jsx(Form.Item, Object.assign({ id: idFormDropDown, name: col.itemname, hasFeedback: true, className: `storybook__fieldItems ${col.className}`, rules: col.colRules, initialValue: col.initialValue }, { children: _jsx(Select, { id: idSelectDropDown, placeholder: col.placeholder, options: col.options, rtl: col.rtl, name: col.name, value: col.value, defaultValue: col.defaultValue, onChange: col.onChange, showSearch: col.showSearch, className: col.childclassname, width: col.width, helperText: col.helperText, headingleft: col.headingleft, headingright: col.headingright, disabled: col.disabled }, void 0) }), void 0));
            case "map":
                return (_jsxs(_Fragment, { children: [_jsx(Form.Item, Object.assign({ name: col.itemname, hasFeedback: true, className: `storybook__fieldItems ${col.className}`, rules: col.colRules }, { children: _jsxs("div", Object.assign({ className: 'storybook__formItem--mapInput' }, { children: [_jsxs("div", Object.assign({ className: "formItem__mapInput-headerSection" }, { children: [_jsx(Typography, Object.assign({ rtl: col.rtl, className: "mapInput-headerLeft" }, { children: col.headingleft }), void 0), _jsx(Typography, Object.assign({ rtl: col.rtl, className: "mapInput-headerRight" }, { children: col.headingright }), void 0)] }), void 0), _jsxs("div", Object.assign({ className: "formItem__mapInput" }, { children: [_jsx(Typography, Object.assign({ className: "mapInput-value" }, { children: (_c = (_b = (_a = this.formRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getFieldValue(col.itemname)) === null || _c === void 0 ? void 0 : _c.address }), void 0), _jsx("img", { src: mapTarget, alt: "loaction", onClick: () => this.toggleMapModalBox(col.itemname) }, void 0)] }), void 0), _jsx("div", Object.assign({ className: "formItem__mapInput-labelSection" }, { children: _jsx(Typography, Object.assign({ rtl: col.rtl, className: "mapInput-labelleft" }, { children: col.labelleft }), void 0) }), void 0)] }), void 0) }), void 0), _jsx(Modal, Object.assign({ centered: true, maskClosable: true, keyboard: true, closable: false, visible: this.state.mapModal, width: 1000, footer: null }, { children: _jsx(Map, { buttonText: col.buttonText, placeholder: col.placeholder, mapTitle: col.mapTitle, googleMapKey: col.googleMapKey, onOk: this.handleAddressChange, handleClose: this.toggleMapModalBox, className: col.childclassname }, void 0) }), void 0)] }, void 0));
            case "button":
                return (_jsx(Form.Item, Object.assign({ id: idFormButton, name: col.itemname, className: `storybook__fieldItems ${col.className}` }, { children: _jsx(Button, Object.assign({ id: idButton }, col, { className: col.childclassname, rtl: col.rtl, primary: col.primary, htmlType: col.htmlType, variant: col.variant }, { children: col.children }), void 0) }), void 0));
            case "iconbutton":
                return (_jsx(Form.Item, Object.assign({ id: idFormIconButton, name: col.itemname, className: `storybook__fieldItems ${col.className}` }, { children: _jsx(IconButton, Object.assign({ id: idIconButton }, col, { className: col.childclassname, rtl: col.rtl, primary: col.primary, htmlType: col.htmlType, variant: col.variant }, { children: col.children }), void 0) }), void 0));
            default:
                return "";
        }
    }
    render() {
        const { formData } = this.props;
        const dir = this.props.rtl ? 'rtl' : 'ltr';
        return (_jsx("div", Object.assign({ className: 'storybook__form--container' }, { children: _jsx(ConfigProvider, Object.assign({ direction: dir }, { children: _jsx(Form, Object.assign({ id: idForm, ref: this.formRef, name: "control-ref", onFinish: this.onFinish }, { children: formData.rows.map((row, i) => {
                        return (_jsx(React.Fragment, { children: row.cols.map((col, j) => {
                                return (_jsx(React.Fragment, { children: this.renderFieldType(col) }, j));
                            }) }, i));
                    }) }), void 0) }), void 0) }), void 0));
    }
}
export default FormComponent;
